/**
 * PhazeFuel Homepage Redesign — DOM Mutations & Interactions
 * CSS/JS overlay for Shopify Horizon v3.4.0
 * No Liquid changes required.
 */
(function () {
  'use strict';

  // ── FOUC Prevention ──────────────────────────
  // Hide body immediately; CSS has a 2s fallback animation
  // in case this script fails entirely.
  document.body.classList.add('pf-loading');

  // ── Helpers ──────────────────────────────────
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'className') node.className = attrs[k];
        else if (k === 'innerHTML') node.innerHTML = attrs[k];
        else node.setAttribute(k, attrs[k]);
      });
    }
    if (children) {
      children.forEach(function (c) {
        if (typeof c === 'string') node.appendChild(document.createTextNode(c));
        else if (c) node.appendChild(c);
      });
    }
    return node;
  }

  // ── Google Fonts ─────────────────────────────
  // Inject preconnects + stylesheet (can't modify theme.liquid)
  function loadFonts() {
    var head = document.head;
    var pc1 = el('link', { rel: 'preconnect', href: 'https://fonts.googleapis.com' });
    var pc2 = el('link', { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' });
    var link = el('link', {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=Outfit:wght@300;400;500;600&display=swap'
    });
    head.appendChild(pc1);
    head.appendChild(pc2);
    head.appendChild(link);
  }

  // ── Hero Transformation ──────────────────────
  function transformHero() {
    var heroSection = qs('[id*="__hero_"]');
    if (!heroSection) return;

    var contentWrapper = qs('.hero__content-wrapper', heroSection);
    if (!contentWrapper) return;

    // Find the heading text block
    var textBlock = qs('.text-block', contentWrapper);
    if (!textBlock) return;

    // 1. Inject tagline BEFORE the heading
    var tagline = el('p', { className: 'pf-hero-tagline' }, ['Clean supplements for female athletes']);
    contentWrapper.insertBefore(tagline, textBlock);

    // 2. Rewrite heading with teal accent
    var headingEl = qs('p, h1, h2', textBlock);
    if (headingEl) {
      headingEl.innerHTML = 'Fuel your <br>performance. <br><em>Naturally.</em>';
    }

    // 3. Add subtitle after heading
    var subtitle = el('p', { className: 'pf-hero-subtitle' }, [
      'Science-backed nutrition designed for female physiology. No fillers. No proprietary blends. Just transparent formulas that work with your body.'
    ]);
    contentWrapper.insertBefore(subtitle, textBlock.nextSibling);

    // 4. Create email signup form (uses Shopify /contact endpoint)
    var form = el('form', {
      className: 'pf-hero-form',
      method: 'post',
      action: '/contact#contact_form'
    });
    form.innerHTML =
      '<input type="hidden" name="form_type" value="customer">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[id]" value="pf-hero-email">' +
      '<input type="email" name="contact[email]" placeholder="Enter your email" required autocomplete="email">' +
      '<button type="submit">Get Early Access</button>';
    subtitle.insertAdjacentElement('afterend', form);

    // 5. Add note below form
    var note = el('p', { className: 'pf-hero-note' }, ['Be first to know when products drop. No spam, ever.']);
    form.insertAdjacentElement('afterend', note);

    // 6. Add scroll indicator
    var heroContainer = qs('.hero__container', heroSection) || qs('.hero', heroSection);
    if (heroContainer) {
      var scroll = el('div', { className: 'pf-hero-scroll' });
      scroll.innerHTML =
        '<span class="pf-hero-scroll-text">Scroll</span>' +
        '<span class="pf-hero-scroll-line"></span>';
      heroContainer.appendChild(scroll);
    }
  }

  // ── Manifesto Stats Card ─────────────────────
  function injectStatsCard() {
    var section = qs('[id*="mission_statement"]');
    if (!section) return;

    var contentWrapper = qs('.section-content-wrapper', section);
    if (!contentWrapper) return;

    // Wrap all existing children in a single container so the grid
    // sees one item in column 1 (text) and one in column 2 (stats card).
    // Without this, each Shopify block is a separate grid item and
    // the rows get stretched to accommodate the spanning stats card.
    var textCol = el('div', { className: 'pf-mission-text' });
    while (contentWrapper.firstChild) {
      textCol.appendChild(contentWrapper.firstChild);
    }
    contentWrapper.appendChild(textCol);

    // Insert "Our Mission" label before the heading
    var heading = qs('.text-block', textCol);
    if (heading) {
      var label = el('div', { className: 'pf-manifesto-label' }, ['Our Mission']);
      textCol.insertBefore(label, heading);
    }

    // Create stats card
    var card = el('div', { className: 'pf-stats-card' });
    card.innerHTML =
      '<div class="pf-stats-list">' +
        '<div class="pf-stat">' +
          '<span class="pf-stat-number">0</span>' +
          '<span class="pf-stat-label">Proprietary blends.<br>Every dose listed.</span>' +
        '</div>' +
        '<div class="pf-stat-divider"></div>' +
        '<div class="pf-stat">' +
          '<span class="pf-stat-number">8</span>' +
          '<span class="pf-stat-label">Research-backed<br>ingredients. Every one listed.</span>' +
        '</div>' +
        '<div class="pf-stat-divider"></div>' +
        '<div>' +
          '<p class="pf-stat-quote">&ldquo;You will not find it.<br>So we built it.&rdquo;</p>' +
          '<p class="pf-stat-author">Leah Klingel, Founder</p>' +
        '</div>' +
      '</div>';
    contentWrapper.appendChild(card);
  }

  // ── Product Section ─────────────────────────
  function injectProductSection() {
    // Insert after mission statement, before blog
    var missionSection = qs('[id*="mission_statement"]');
    if (!missionSection) return;

    var section = el('section', { className: 'pf-product', id: 'pf-product' });
    section.innerHTML =
      '<div class="pf-product__inner">' +
        '<div class="pf-product__header" data-pf-reveal>' +
          '<p class="pf-product__label">The Product</p>' +
          '<h2 class="pf-product__headline">Built for your cycle.<br>Not around it.</h2>' +
          '<p class="pf-product__intro">One daily capsule with eight research-backed ingredients, dosed for female physiology. Not a pink-washed multivitamin. Not hormone therapy. The specific nutrients your body actually needs to perform through every phase.</p>' +
        '</div>' +
        '<div class="pf-product__grid">' +
          // Card 1: Cycle Support
          '<div class="pf-product__card" data-pf-reveal>' +
            '<div class="pf-product__card-icon">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>' +
              '</svg>' +
            '</div>' +
            '<h3 class="pf-product__card-title">Cycle Support</h3>' +
            '<p class="pf-product__card-body">Magnesium Glycinate and Vitamin B6 (P-5-P) support your body through every phase\u2009\u2014\u2009helping maintain energy metabolism and muscle function when you need it most.</p>' +
          '</div>' +
          // Card 2: Anti-Inflammation
          '<div class="pf-product__card" data-pf-reveal>' +
            '<div class="pf-product__card-icon">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>' +
              '</svg>' +
            '</div>' +
            '<h3 class="pf-product__card-title">Recovery Support</h3>' +
            '<p class="pf-product__card-body">Curcumin with Black Pepper for enhanced absorption, plus Ginger Extract and Nettle Leaf. Ingredients traditionally used to support your body\u2019s natural recovery process.</p>' +
          '</div>' +
          // Card 3: Transparent Formula
          '<div class="pf-product__card" data-pf-reveal>' +
            '<div class="pf-product__card-icon">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>' +
                '<polyline points="9 12 11 14 15 10"/>' +
              '</svg>' +
            '</div>' +
            '<h3 class="pf-product__card-title">Transparent Formula</h3>' +
            '<p class="pf-product__card-body">Every ingredient. Every dose. On the label. No proprietary blends hiding behind \u201Ccomplexes.\u201D You deserve to know exactly what you\u2019re putting in your body.</p>' +
          '</div>' +
        '</div>' +
        '<div class="pf-product__ingredients" data-pf-reveal>' +
          '<span>Magnesium Glycinate</span>' +
          '<span class="pf-product__dot"></span>' +
          '<span>Ginger Extract</span>' +
          '<span class="pf-product__dot"></span>' +
          '<span>Curcumin</span>' +
          '<span class="pf-product__dot"></span>' +
          '<span>Iron Bisglycinate</span>' +
          '<span class="pf-product__dot"></span>' +
          '<span>Vitamin B6</span>' +
          '<span class="pf-product__dot"></span>' +
          '<span>Nettle Leaf</span>' +
          '<span class="pf-product__dot"></span>' +
          '<span>Vitamin C</span>' +
          '<span class="pf-product__dot"></span>' +
          '<span>Black Pepper</span>' +
        '</div>' +
        '<div class="pf-product__cta" data-pf-reveal>' +
          '<button onclick="document.getElementById(\'cta\') ? document.getElementById(\'cta\').scrollIntoView({behavior:\'smooth\'}) : window.scrollTo({top:document.body.scrollHeight,behavior:\'smooth\'})">' +
            'Get Early Access' +
          '</button>' +
        '</div>' +
      '</div>';

    // Insert after mission section's parent (the Shopify section wrapper)
    var insertAfter = missionSection;
    if (insertAfter.nextSibling) {
      insertAfter.parentNode.insertBefore(section, insertAfter.nextSibling);
    } else {
      insertAfter.parentNode.appendChild(section);
    }
  }

  // ── Blog Header Enhancement ──────────────────
  function enhanceBlogSection() {
    var section = qs('[id*="featured_blog"]');
    if (!section) return;

    // Find the blog title block
    var titleBlock = qs('.shopify-block', section);
    if (!titleBlock) return;

    // Replace "Blog" with "Latest from the blog"
    var titleEl = qs('h3', titleBlock);
    if (titleEl) {
      titleEl.textContent = 'Latest from the blog';
    }

    // Add "View all" link next to title
    var viewAll = el('a', {
      className: 'pf-view-all',
      href: '/blogs/news',
      innerHTML: 'View all <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>'
    });

    // Wrap title and view-all in a flex header
    var header = el('div', { className: 'pf-blog-header' });
    titleBlock.parentNode.insertBefore(header, titleBlock);
    header.appendChild(titleBlock);
    header.appendChild(viewAll);
  }

  // ── CTA Section Enhancement ──────────────────
  function enhanceCTA() {
    var section = qs('[id*="coming_soon_cta"]');
    if (!section) return;

    var contentWrapper = qs('.section-content-wrapper', section);
    if (!contentWrapper) return;

    // Inject lightning bolt icon before heading
    var heading = qs('.text-block', contentWrapper);
    if (heading) {
      var icon = el('div', { className: 'pf-cta-icon' });
      icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>';
      heading.parentNode.insertBefore(icon, heading);
    }

    // Inject trust badges after the email signup
    var emailBlock = qs('.email-signup-block', contentWrapper);
    if (emailBlock) {
      var badges = el('div', { className: 'pf-trust-badges' });
      badges.innerHTML =
        '<span>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
          'No spam, ever' +
        '</span>' +
        '<span>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
          'Unsubscribe anytime' +
        '</span>' +
        '<span>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' +
          'Your data stays private' +
        '</span>';
      emailBlock.insertAdjacentElement('afterend', badges);
    }
  }

  // ── Scroll Reveal (Fixed) ────────────────────
  // Theme's built-in observer uses threshold 0.15 which fails
  // on tall sections that never reach 15% visibility.
  // This uses 0.05 threshold + negative rootMargin.
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: show everything
      qsa('.reveal, [data-pf-reveal]').forEach(function (el) {
        el.classList.add('visible');
        el.classList.add('pf-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          entry.target.classList.add('pf-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -40px 0px'
    });

    // Observe theme's reveal elements that aren't yet visible
    qsa('.reveal:not(.visible)').forEach(function (el) {
      observer.observe(el);
    });

    // Observe our custom reveal elements
    qsa('[data-pf-reveal]:not(.pf-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  // ── Nav Scroll Effect ────────────────────────
  // We override header to position:fixed which breaks Shopify's
  // built-in sticky detection. Toggle data-sticky-state ourselves.
  function initNavScroll() {
    var header = qs('.header');
    if (!header) return;

    var threshold = 80; // px from top before triggering
    var scrollTicking = false;

    function updateHeader() {
      if (window.scrollY > threshold) {
        header.setAttribute('data-sticky-state', 'active');
      } else {
        header.setAttribute('data-sticky-state', 'inactive');
      }
      scrollTicking = false;
    }

    window.addEventListener('scroll', function () {
      if (!scrollTicking) {
        requestAnimationFrame(updateHeader);
        scrollTicking = true;
      }
    });

    // Set initial state
    updateHeader();
  }

  // ── Hero Parallax (optional) ─────────────────
  function initParallax() {
    var heroImg = qs('[id*="__hero_"] .hero__media');
    if (!heroImg) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrolled = window.scrollY;
          if (scrolled < window.innerHeight) {
            heroImg.style.transform = 'scale(' + (1 + scrolled * 0.0001) + ') translateY(' + (scrolled * 0.15) + 'px)';
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // ── Init ─────────────────────────────────────
  function init() {
    loadFonts();
    transformHero();
    injectStatsCard();
    injectProductSection();
    enhanceBlogSection();
    enhanceCTA();

    // Swap loading → ready (triggers CSS opacity transition)
    document.body.classList.remove('pf-loading');
    document.body.classList.add('pf-ready');

    // Nav scroll state + reveal + parallax after a short delay to ensure paint
    requestAnimationFrame(function () {
      initNavScroll();
      initScrollReveal();
      initParallax();
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
